/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_SubtitleInputs */

const cs_pipelines_subtitle = /** @type {(inputs: Pipelines_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nástěnky obchodů a úkolů pro organizaci.`)
};

const en_pipelines_subtitle = /** @type {(inputs: Pipelines_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal and task boards for the organization.`)
};

/**
* | output |
* | --- |
* | "Deal and task boards for the organization." |
*
* @param {Pipelines_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_subtitle = /** @type {((inputs?: Pipelines_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_subtitle(inputs)
	return cs_pipelines_subtitle(inputs)
});